import { FC, useState } from 'react';
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@material-ui/icons/Delete';
import BlockIcon from '@material-ui/icons/Block';
import Person from '@material-ui/icons/Person';
import AddCircle from '@material-ui/icons/AddCircle';

import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';

import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './styles';
import {
    thunkToggleAdminUser,
    thunkToggleBlockUser,
} from '../../../../../../store/actions/Streaming.actions';
import BlockUserDialog from '../../../BlockUserDialog';
import AdminUserDialog from '../../../AdminUserDialog';
import { CurrentUserReducer, RootReducer } from '../../../../../../models/Redux';

interface ViewerDialogItemPros {
    avatar: string;
    username: string;
    isEventInfluencer: boolean;
    isBanned: boolean;
    isAdmin: boolean;
    mobileLayout?: boolean;
}

const ViewerDialogItem: FC<ViewerDialogItemPros> = ({
    avatar,
    username,
    isBanned,
    isAdmin,
    isEventInfluencer,
    mobileLayout,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showBlockModal, setShowBlockModal] = useState<boolean>(false);
    const [showAdminModal, setShowAdminModal] = useState<boolean>(false);
    const {
        user: { user_username: userUsername },
    } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    const toggleUserBlocked = () => {
        if (username) {
            dispatch(thunkToggleBlockUser(username));
        }
    };

    const toggleUserAdmin = () => {
        if (username) {
            dispatch(thunkToggleAdminUser(username));
        }
    };

    return (
        <Grid
            container
            justify="center"
            alignContent="center"
            alignItems="center"
            direction="column"
            xs={mobileLayout ? 6 : 3}
            className={classes.container}
        >
            <Grid
                container
                item
                justify="flex-start"
                alignContent="center"
                alignItems="center"
                direction="column"
            >
                <BlockUserDialog
                    open={showBlockModal}
                    onDismiss={() => setShowBlockModal(false)}
                    user={username}
                    isBanned={isBanned}
                    onAcceptEvent={() => {
                        toggleUserBlocked();
                        setShowBlockModal(false);
                    }}
                />

                <AdminUserDialog
                    open={showAdminModal}
                    onDismiss={() => setShowAdminModal(false)}
                    user={username}
                    isAdmin={isAdmin}
                    onAcceptEvent={() => {
                        toggleUserAdmin();
                        setShowAdminModal(false);
                    }}
                />
                <Tooltip
                    // @ts-ignore
                    title={isAdmin ? t('Admin {{username}}', { username }) : username}
                >
                    <img
                        className={clsx(classes.avatar, isAdmin ? classes.adminUser : '')}
                        src={avatar}
                        alt={t('{{username}} user', { username })}
                    />
                </Tooltip>
                <Typography className={classes.usernameText}>{username}</Typography>
            </Grid>

            {userUsername !== username && (
                <Grid container justify="center" alignContent="center" alignItems="center" direction="row">
                    {false && (
                        <IconButton onClick={() => {}}>
                            {isBanned ? (
                                <BlockIcon className={classes.icon} />
                            ) : (
                                <DeleteIcon className={classes.icon} />
                            )}
                        </IconButton>
                    )}
                    {isEventInfluencer && (
                        <Tooltip
                            // @ts-ignore
                            title={isAdmin ? t('Downgrade to viewer') : t('Promote to admin')}
                        >
                            <IconButton
                                onClick={() => {
                                    setShowAdminModal(true);
                                }}
                            >
                                {isAdmin ? (
                                    <Person className={classes.icon} />
                                ) : (
                                    <SupervisedUserCircle className={classes.icon} />
                                )}
                            </IconButton>
                        </Tooltip>
                    )}

                    <Tooltip
                        // @ts-ignore
                        title={isBanned ? t('Unblock user') : t('Block user')}
                    >
                        <IconButton
                            onClick={() => {
                                setShowBlockModal(true);
                            }}
                        >
                            {isBanned ? (
                                <AddCircle className={classes.icon} />
                            ) : (
                                <BlockIcon className={classes.icon} />
                            )}
                        </IconButton>
                    </Tooltip>
                </Grid>
            )}
        </Grid>
    );
};

export default ViewerDialogItem;
